var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{ref:"img",staticClass:"avatar-icon img-fluid rounded-circle",attrs:{"src":_vm.shadowURL}})
}
var staticRenderFns = []

export { render, staticRenderFns }